import {Component, OnInit} from '@angular/core';
import {GalleryService} from "../../../shared/services/gallery.service";
import {Lightbox} from 'ngx-lightbox';

@Component({
    selector: 'app-photogallery',
    templateUrl: './photogallery.component.html',
    styleUrls: ['./photogallery.component.scss']
})
export class PhotogalleryComponent implements OnInit {
    galleries: any;
    _album: [];

    constructor(
        private galleryService: GalleryService,
        private lightbox: Lightbox
    ) {

    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.get();
    }

    get() {
        this.galleryService.get({}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.galleries = data['data'];
                this.galleries.forEach(item => {
                    this._album = item?.images?.map((img) => ({
                        src: img?.url,
                        caption: img?.name
                    }));
                })


            }
        })
    }

    openLightbox(index: number): void {
        this.lightbox.open(this._album, index);
    }

    closeLightbox(): void {
        this.lightbox.close();
    }

}
